import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { formatLabel } from '@project/shared/utils/labels/js/labels';
import 'select2';

const classes = {
	filterBtn: "o-sds-search__apply-button",
	clearBtn: "o-sds-search__clear-button",
	loadMoreBtn: "o-sds-search__load-more-button",
	loadMoreBar: "js-load-more-bar",
	materialNumber: "js-o-sds-search_material-number",
	productName: "js-o-sds-search_product-name",
	country: "js-o-sds-search_country",
	language: "js-o-sds-search_language",

	tbody: "js-m-table__body",
	tRow: "js-o-sds-search__result-item",
	resultContent: "js-result-content",
	noResultContent: "js-no-result-content",

	stateLoadMoreHide: "state-o-sds-search__load-more--hidden",
	stateResultContentHide: "state-o-sds-search__result-content--hidden",
	stateErrorMsgHide: "o-sds-search__error-hidden",
	stateLoadingIndicatorHide: "state-o-sds-search__loading--hidden",
	stateResultItemHide: "state-o-sds-search__result-item--hidden",

	topMessage: "js-o-sds-search__top-message",
	bottomMessage: "js-o-sds-search__bottom-message",

	materialNumberTHeader: "js-materialnumber-header",
	productNameTHeader: "js-productname-header",
	dateTHeader: "js-date-header",
	languageTHeader: "js-language-header",
	linkTHeader: "js-link-header",

	errorContainer: "validation-summary-errors",
	nameNumberError: "js-error-number-name",
	eithernameNumberError: "js-error-either-number-name",
	languageError: "js-error-language",
	areError: "js-error-area",

	contentLoading: "js-content-loading",
	loadMoreLoading: "js-loadmore-loading",

	loadModalOverlay: "m-modal-overlay",
	loadModalOverlayVisible: "state-m-modal-overlay--visible"
}

@createModule('SafetyDataSheetSearch')
export class SafetyDataSheetSearch extends TerrificSpec {
	$ctx: JQuery;

	pageSize: number;
	topResultMsg: string;
	bottomResultMsg: string;
	url: string;
	urlLanAndCountry: string;

	materialNumberTHeader: string;
	productNameTHeader: string;
	dateTHeader: string;
	languageTHeader: string;
	linkTHeader: string;
	languageInnerHtml: any;
	resultResponse: any;
	langScript: any;

	tableBodyEle: JQuery<HTMLElement>;
	tableRowEle: JQuery<HTMLElement>;
	resultContentEle: JQuery<HTMLElement>;
	noResultContentEle: JQuery<HTMLElement>;
	topResultMsgEle: JQuery<HTMLElement>;
	bottomResultMsgEle: JQuery<HTMLElement>;

	materialNumberInputEle: JQuery<HTMLElement>;
	productNameInputEle: JQuery<HTMLElement>;
	languageSelectEle: JQuery<HTMLElement>;
	countrySelectEle: JQuery<HTMLElement>;

	errorContainerEle: JQuery<HTMLElement>;

	applyBtnEle: JQuery<HTMLElement>;
	clearBtnEle: JQuery<HTMLElement>;
	loadMoreBtnEle: JQuery<HTMLElement>;
	loadModalOverlayEle: JQuery<HTMLElement>;

	contentLoadingEle: JQuery<HTMLElement>;
	loadMoreLoadingEle: JQuery<HTMLElement>;
	SearchDigit: any;
	SearchName: any;

	start(resolve: Function) {
		this.$ctx = $(this._ctx);

		this.pageSize = this.$ctx.data("page-size");
		this.topResultMsg = this.$ctx.data("top-message");
		this.bottomResultMsg = this.$ctx.data("bottom-message");
		this.url = "/api/uwsi/getsdslist";
		this.urlLanAndCountry = "/api/uwsi/getsdslangandcountrylist";

		this.materialNumberTHeader = this.$ctx.find(`.${classes.materialNumberTHeader}`).text();
		this.productNameTHeader = this.$ctx.find(`.${classes.productNameTHeader}`).text();
		this.dateTHeader = this.$ctx.find(`.${classes.dateTHeader}`).text();
		this.languageTHeader = this.$ctx.find(`.${classes.languageTHeader}`).text();
		this.linkTHeader = this.$ctx.find(`.${classes.linkTHeader}`).text();

		this.tableBodyEle = this.$ctx.find(`.${classes.tbody}`);
		this.tableRowEle = this.$ctx.find(`.${classes.tRow}`);
		this.resultContentEle = this.$ctx.find(`.${classes.resultContent}`);
		this.noResultContentEle = this.$ctx.find(`.${classes.noResultContent}`);

		this.topResultMsgEle = this.$ctx.find(`.${classes.topMessage}`);
		this.bottomResultMsgEle = this.$ctx.find(`.${classes.bottomMessage}`);

		this.materialNumberInputEle = this.$ctx.find(`.${classes.materialNumber}`);
		this.productNameInputEle = this.$ctx.find(`.${classes.productName}`);

		this.languageSelectEle = this.$ctx.find(`.${classes.language}`);
		this.countrySelectEle = this.$ctx.find(`.${classes.country}`);

		this.errorContainerEle = this.$ctx.find(`.${classes.errorContainer}`);

		this.applyBtnEle = this.$ctx.find(`.${classes.filterBtn}`);
		this.clearBtnEle = this.$ctx.find(`.${classes.clearBtn}`);
		this.loadMoreBtnEle = this.$ctx.find(`.${classes.loadMoreBtn}`);

		this.contentLoadingEle = this.$ctx.find(`.${classes.contentLoading}`);
		this.loadMoreLoadingEle = this.$ctx.find(`.${classes.loadMoreLoading}`);
		this.loadModalOverlayEle = $(`.${classes.loadModalOverlay}`);

		const handleKeyDown = (event: JQuery.Event) => {
			const inputValue = $(event.target).val().toString();
			if (event.key === "Enter" && inputValue.length > 0) {
				this.applyFilter();
				this.getProductorMaterialData();
			}
		};

		$(this.productNameInputEle).on("keydown", handleKeyDown);
		$(this.materialNumberInputEle).on("keydown", handleKeyDown);

		let preventBlurone = false;
		this.applyBtnEle.on('mousedown', function () {
			preventBlurone = true;
		});

		this.applyBtnEle.on("click", () => {
			this.applyFilter();
		});
		this.clearBtnEle.on("click", this.clear.bind(this));
		this.loadMoreBtnEle.on("click", this.loadMore.bind(this));

		this.countrySelectEle.on("change", this.getLanguagebyCountry.bind(this));
		this.productNameInputEle.on('blur', () => {
			if (preventBlurone) {
				preventBlurone = false;
				return;
			}
			else {
				this.checkInputHasValue();
			}
		});
		this.materialNumberInputEle.on('blur', () => {
			if (preventBlurone) {
				preventBlurone = false;
				return;
			}
			else {
				this.checkInputHasValue();
			}
		});

		$(window).on("load", () => {
			$('.js-o-sds-search_language').prop("disabled", true);
			$('.js-o-sds-search_country').prop("disabled", true);
		});

		var sPageURL = window.location.search.substring(1),
			sURLVariables = sPageURL.split('&'),
			sParameterName: string[],
			i: number;
		for (i = 0; i < sURLVariables.length; i++) {
			sParameterName = sURLVariables[i].split('=');
			if (sParameterName[0] === 'SearchDigit') {
				sParameterName[1] === undefined ? true : $(".js-o-sds-search_material-number").val(decodeURIComponent(sParameterName[1]));
			}
		}

		var sPageURL = window.location.search.substring(1),
			sURLVariables = sPageURL.split('&'),
			sParameterName1: string[],
			i: number;
		for (i = 0; i < sURLVariables.length; i++) {
			sParameterName1 = sURLVariables[i].split('=');
			if (sParameterName1[0] === 'SearchName') {
				sParameterName1[1] === undefined ? true : $(".js-o-sds-search_product-name").val(decodeURIComponent(sParameterName1[1]));
			}
		}

		$(classes.filterBtn).trigger("click");
		this.langScript = document.createElement("script");
		this.langScript.type = "application/json";

		resolve();

	}

	getlanguageJsonData() {
		this.languageInnerHtml = this.$ctx.find("script[type='application/json']");
		const json = this.languageInnerHtml[0].innerHTML;
		const jsonData = JSON.parse(json);
		return jsonData;
	}

	getUrlParameter(sParam: any) {
		var sPageURL = window.location.search.substring(1),
			sURLVariables = sPageURL.split('&'),
			sParameterName: string[],
			i: number;

		for (i = 0; i < sURLVariables.length; i++) {
			sParameterName = sURLVariables[i].split('=');

			if (sParameterName[0] === sParam) {
				return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
			}
		}
		return false;
	};

	applyFilter() {
		this.clearResults();
		if (this.validate()) {
			this.showContentLoading();
			this.getData();
		}
	}

	checkInputHasValue() {
		this.cleardropdown();
		if (this.validate()) {
			this.getProductorMaterialData();
			return true;
		}
	}

	getProductorMaterialData() {
		let productNumber = $.trim(this.materialNumberInputEle.val().toString());
		let productName = $.trim(this.productNameInputEle.val().toString());
		this.showContentLoading();
		this.lockButtons();

		$.ajax({
			type: 'POST',
			url: this.urlLanAndCountry,
			dataType: 'json',
			data:
			{
				productNumber: productNumber,
				productName: productName,
			},
			success: (response: any) => {
				if (response) {
					$('.js-o-sds-search_language').prop("disabled", true);
					$('.js-o-sds-search_country').prop("disabled", false);
					let jsonresponse = JSON.stringify(response.sdsSheet);
					const container = this.$ctx.find("body");
					const data = container.find("script[type='application/json']");
					if (data != null && jsonresponse != null && this.langScript.type.length > 0) {
						this.langScript.innerHTML = jsonresponse;
						this.$ctx.append(this.langScript);
					}
					let resultsCountry = response.sdsCountry;
					let elcountry = $('.js-o-sds-search_country') as any;
					var countryList = $("option", elcountry);
					if (resultsCountry.length > 0) {
						$.each(countryList, function (countryidx, countryitem: any) {
							if (countryidx !== 0 && $.trim(countryitem.value) !== "") {
								var itemIndex = resultsCountry.indexOf($.trim(countryitem.value));
								if (itemIndex === -1) {
									countryitem.disabled = true;
								}
								else {
									countryitem.disabled = false;
								}
							}
						});
						this.unlockButtons();
					}
					else {
						$.each(countryList, function (countryidx, countryitem: any) {
							if (countryidx !== 0 && $.trim(countryitem.value) !== "") {
								countryitem.disabled = true;
							}
						});
						this.lockButtons();
					}
					var countrySearch = elcountry.attr('data-search') ? 0 : -1;
					elcountry.select2({
						minimumResultsForSearch: countrySearch,
						width: '100%'
					});
				}
				this.hideContentLoading();
			},
			error: (xhr: any, status: string, error: string) => {
				console.log(`get sds data errror, ${xhr.status}, ${xhr.statusText}, ${error}`);
				this.hideContentLoading();
			}
		});
	}

	getLanguagebyCountry() {
		this.resultResponse = this.getlanguageJsonData();
		if (this.resultResponse != null) {
			$('.js-o-sds-search_language').prop("disabled", false);
			let selectedCountry = $('.js-o-sds-search_country').val();
			let sdsLanguageBasedOnCountry: Array<string> = [];
			$.each(this.resultResponse, function (langidx: any, sdsElement: any) {
				if (sdsElement.country == selectedCountry) {
					sdsLanguageBasedOnCountry.push(sdsElement.language);
				}
			});
			let ellanguage = $('.js-o-sds-search_language') as any;
			var languageList = $("option", ellanguage);
			if (sdsLanguageBasedOnCountry.length > 0) {
				$.each(languageList, function (langidx: any, langItem: any) {
					if (langidx !== 0 && $.trim(langItem.value) !== "") {
						var itemIndex = sdsLanguageBasedOnCountry.indexOf($.trim(langItem.value));
						if (itemIndex === -1) {
							langItem.disabled = true;
						}
						else {
							langItem.disabled = false;
						}
					}
				});
			}
			else {
				$.each(languageList, function (langidx, langItem: any) {
					if (langidx !== 0 && $.trim(langItem.value) !== "") {
						langItem.disabled = true;
					}
				});
			}

			var langSearch = ellanguage.attr('data-search') ? 0 : -1;
			ellanguage.select2({
				minimumResultsForSearch: langSearch,
				width: '100%'
			});
		}
	}
	cleardropdown() {
		// reset language dropdown
		this.languageSelectEle.find("option[value='']").prop("selected", true);
		let lngDefaultText = this.languageSelectEle.find("option[value='']").text();
		let lngRenderEle = this.languageSelectEle.next(".select2").find(".select2-selection__rendered");
		lngRenderEle.text(lngDefaultText);
		lngRenderEle.attr("title", lngDefaultText);

		// reset area dropdown
		this.countrySelectEle.find("option[value='']").prop("selected", true);
		let coDefaultText = this.countrySelectEle.find("option[value='']").text();
		let coRenderEle = this.countrySelectEle.next(".select2").find(".select2-selection__rendered");
		coRenderEle.text(coDefaultText);
		coRenderEle.attr("title", coDefaultText);
	}
	clear() {
		this.clearFilters();
		this.clearResults();
		var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
		window.history.pushState({ path: newurl }, '', newurl);
	}

	loadMore() {
		this.setStaticPaging();
		this.updateResultMessage();
	}

	clearResults() {
		this.tableBodyEle.empty();
		this.topResultMsgEle.empty();
		this.bottomResultMsgEle.empty();

		this.resultContentEle.addClass(classes.stateResultContentHide);
		this.noResultContentEle.addClass(classes.stateResultContentHide);
	}

	clearFilters() {
		this.productNameInputEle.val("");
		this.materialNumberInputEle.val("");

		// reset language dropdown
		this.languageSelectEle.find("option[value='']").prop("selected", true);
		let lngDefaultText = this.languageSelectEle.find("option[value='']").text();
		let lngRenderEle = this.languageSelectEle.next(".select2").find(".select2-selection__rendered");
		lngRenderEle.text(lngDefaultText);
		lngRenderEle.attr("title", lngDefaultText);

		// reset area dropdown
		this.countrySelectEle.find("option[value='']").prop("selected", true);
		let coDefaultText = this.countrySelectEle.find("option[value='']").text();
		let coRenderEle = this.countrySelectEle.next(".select2").find(".select2-selection__rendered");
		coRenderEle.text(coDefaultText);
		coRenderEle.attr("title", coDefaultText);
	}

	getData() {
		let productNumber = $.trim(this.materialNumberInputEle.val().toString());
		let productName = $.trim(this.productNameInputEle.val().toString());
		let language = this.languageSelectEle.find("option:selected").val();
		let country = this.countrySelectEle.find("option:selected").val();
		this.lockButtons();
		this.showContentLoading();

		$.ajax({
			type: 'POST',
			url: this.url,
			dataType: 'json',
			data:
			{
				productNumber: productNumber,
				productName: productName,
				language: language,
				country: country,
			},
			success: (response: any) => {
				if (response) {
					if (response.total > 0) {
						this.updateResultContentState(true);
						let results = response.results;
						if (results) {
							this.renderResultDataOnPage(results);
							this.setStaticPaging();
							this.updateResultMessage();
						}
					} else {
						this.updateResultContentState(false);
					}
				} else {
					this.updateResultContentState(false);
				}
				this.unlockButtons();
				this.hideContentLoading();
			},
			error: (xhr: any, status: string, error: string) => {
				console.log(`get sds data errror, ${xhr.status}, ${xhr.statusText}, ${error}`);
				this.unlockButtons();
				this.hideContentLoading();
			}
		});
	}

	renderResultDataOnPage(results: any) {
		results.forEach((r: any) => {

			let materialNumber = r.productNumber;
			let productName = r.productName;
			let date = r.date;
			let lng = r.languageAndCountry;
			let link = r.link;

			let htmlContent = this.generateHtmlData(materialNumber, productName, date, lng, link);
			this.tableBodyEle.append(htmlContent);

		});

	}

	generateHtmlData(materialNumber: string, productName: string, date: string, LngAndArea: string, link: string) {
		var htmlContent =
			`<tr class="m-table__row js-o-sds-search__result-item ${classes.stateResultItemHide}">
                <td class="m-table__body-cell" data-label="${this.materialNumberTHeader}">${materialNumber}</td>
                <td class="m-table__body-cell" data-label="${this.productNameTHeader}">${productName}</td>
                <td class="m-table__body-cell" data-label="${this.dateTHeader}">${date}</td>
                <td class="m-table__body-cell" data-label="${this.languageTHeader}">${LngAndArea}</td>
                <td class="m-table__body-cell" data-label="${this.linkTHeader}"><a href="${link}" class="o-sds-search__icon-pdf"></a></td>
            </tr>`
		return htmlContent;
	}

	updateResultMessage() {
		let currentCount = this.$ctx.find(`.${classes.tRow}:not(.${classes.stateResultItemHide})`).length;
		let total = this.$ctx.find(`.${classes.tRow}`).length;

		let topMessage = formatLabel(this.topResultMsg, total);
		let bottomMessage = formatLabel(this.bottomResultMsg, currentCount, total);

		this.topResultMsgEle.html(topMessage);
		this.bottomResultMsgEle.html(bottomMessage);

		if (currentCount >= total) {
			this.$ctx.find(`.${classes.loadMoreBar}`).addClass(classes.stateLoadMoreHide);
		} else {
			this.$ctx.find(`.${classes.loadMoreBar}`).removeClass(classes.stateLoadMoreHide);
		}

	}

	setStaticPaging() {
		this.$ctx.find(`.${classes.stateResultItemHide}:lt(${this.pageSize})`).removeClass(classes.stateResultItemHide);
	}

	validate(): boolean {
		var result = true;
		let number = $.trim(this.materialNumberInputEle.val().toString());
		let name = $.trim(this.productNameInputEle.val().toString());
		let lng = this.languageSelectEle.find("option:selected").val();
		let country = this.countrySelectEle.find("option:selected").val();

		var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?SearchDigit=' + number + '&SearchName=' + name + '&SelectedLanguage=' + lng + '&SelectedCountry=' + country;
		window.history.pushState({ path: newurl }, '', newurl);

		if (number === "" && name === "") {
			this.errorContainerEle.find(`.${classes.nameNumberError}`).removeClass(classes.stateErrorMsgHide);
			this.materialNumberInputEle.css('border', '1px solid red');
			this.productNameInputEle.css('border', '1px solid red');
			result = false;
		} else {
			if (number !== "" && name !== "") {
				this.errorContainerEle.find(`.${classes.eithernameNumberError}`).removeClass(classes.stateErrorMsgHide);
				this.materialNumberInputEle.css('border', '1px solid red');
				this.productNameInputEle.css('border', '1px solid red');
				result = false;
			}
			else {
				this.materialNumberInputEle.css('border', '');
				this.productNameInputEle.css('border', '');
				this.errorContainerEle.find(`.${classes.nameNumberError}`).addClass(classes.stateErrorMsgHide);
				this.errorContainerEle.find(`.${classes.eithernameNumberError}`).addClass(classes.stateErrorMsgHide);
			}
		}

		// update error messages contianer
		let totalErrors = this.errorContainerEle.find("li").length;
		let activeErrors = this.errorContainerEle.find(`li.${classes.stateErrorMsgHide}`).length;
		if (totalErrors == activeErrors) {
			this.errorContainerEle.addClass(classes.stateErrorMsgHide);
		} else {

			this.errorContainerEle.removeClass(classes.stateErrorMsgHide);
		}
		return result;
	}


	updateResultContentState(anyResult: boolean) {
		if (anyResult) {
			this.noResultContentEle.addClass(classes.stateResultContentHide);
			this.resultContentEle.removeClass(classes.stateResultContentHide);
		} else {
			this.noResultContentEle.removeClass(classes.stateResultContentHide);
			this.resultContentEle.addClass(classes.stateResultContentHide);
		}
	}

	// lock "apply filter", "clear", "load more" button before ajax returns
	lockButtons() {
		this.applyBtnEle.attr("disabled", "disabled");
		this.clearBtnEle.attr("disabled", "disabled");
		this.loadMoreBtnEle.attr("disabled", "disabled");
	}

	unlockButtons() {
		this.applyBtnEle.removeAttr("disabled");
		this.clearBtnEle.removeAttr("disabled");
		this.loadMoreBtnEle.removeAttr("disabled");
	}

	showContentLoading() {
		this.contentLoadingEle.removeClass(classes.stateLoadingIndicatorHide);
		document.getElementsByClassName("m-modal-overlay")[0].classList.add("state-m-modal-overlay--visible")
	}

	hideContentLoading() {
		this.contentLoadingEle.addClass(classes.stateLoadingIndicatorHide);
		document.getElementsByClassName("m-modal-overlay")[0].classList.remove("state-m-modal-overlay--visible");
	}

	showLoadMoreLoading() {
		this.loadMoreLoadingEle.removeClass(classes.stateLoadingIndicatorHide);
	}

	hideLoadMoreLoading() {
		this.loadMoreLoadingEle.addClass(classes.stateLoadingIndicatorHide);
	}

	stop() { }

}
